@keyframes fade {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.screen {
  position: fixed;
  inset: 0;
  top: 48px;
  z-index: var(--z-index-mid);
  height: calc(100vh - 48px);
  overflow: hidden;
  background-color: #f3f3f3;
  animation: fade 0.2s ease-in-out;
}

.container {
  width: 100%;
  height: 100%;
  padding: 17px 15px 0;
}

.inputWrapper {
  position: relative;
}

.input {
  width: 100%;
  height: 40px;
  padding: 0 42px;
  font-size: var(--font-size-sm);
  color: #333;
  outline: none;
  background-color: var(--color-white);
  border: 1px solid #e4e4e4;
  border-radius: 50px;
}

.searchIcon {
  position: absolute;
  top: 50%;
  left: 13px;
  transform: translate(0, -50%);
}

.closeIcon {
  position: absolute;
  top: 50%;
  right: 13px;
  width: 18px;
  height: 18px;
  transform: translate(0, -50%);
}
